"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedInsightDialog = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var sdk_ui_1 = require("@gooddata/sdk-ui");
var react_1 = tslib_1.__importStar(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var VisualizationCatalog_1 = require("../../VisualizationCatalog");
var insightViewCodeGenerator_1 = require("../../../utils/embeddingInsightViewCodeGenerator/insightViewCodeGenerator");
var INSIGHT_VIEW_PROPERTIES_LINK = "https://sdk.gooddata.com/gooddata-ui/docs/visualization_component.html#properties";
/**
 * @internal
 */
exports.EmbedInsightDialog = function (props) {
    var locale = props.locale, insight = props.insight, backend = props.backend, settings = props.settings, colorPalette = props.colorPalette, executionConfig = props.executionConfig, codeType = props.codeType, integrationDocLink = props.integrationDocLink, onClose = props.onClose, onCopyCode = props.onCopyCode;
    var _a = react_1.useState("ts"), codeLang = _a[0], setCodeLang = _a[1];
    var _b = react_1.useState(sdk_ui_kit_1.getDefaultEmbedCodeOptions(codeType)), codeOption = _b[0], setCodeOption = _b[1];
    react_1.useEffect(function () {
        setCodeOption(sdk_ui_kit_1.getDefaultEmbedCodeOptions(codeType));
    }, [codeType]);
    var onLanguageChange = react_1.useCallback(function (codeLanguage) {
        setCodeLang(codeLanguage);
    }, []);
    var code = react_1.useMemo(function () {
        var inputBase = {
            insight: insight,
            settings: settings,
            backend: backend,
            colorPalette: colorPalette,
            executionConfig: executionConfig,
            codeLang: codeLang,
        };
        return codeOption.type === "definition"
            ? generateCodeByDefinition(tslib_1.__assign(tslib_1.__assign({}, inputBase), { codeOption: codeOption }))
            : generateCodeByReference(tslib_1.__assign(tslib_1.__assign({}, inputBase), { codeOption: codeOption }));
    }, [codeOption, insight, settings, backend, colorPalette, executionConfig, codeLang]);
    var onCodeOptionChange = react_1.useCallback(function (codeOpt) {
        setCodeOption(codeOpt);
    }, []);
    var documentationLink = react_1.useMemo(function () { return getLinkToPropertiesDocumentation(codeType, insight); }, [codeType, insight]);
    return (react_1.default.createElement(sdk_ui_1.IntlWrapper, { locale: locale },
        react_1.default.createElement(ModalOverlay, null,
            react_1.default.createElement(sdk_ui_kit_1.EmbedInsightDialogBase, { code: code, codeLanguage: codeLang, codeOption: codeOption, propertiesLink: documentationLink, integrationDocLink: integrationDocLink, onClose: onClose, onCopyCode: onCopyCode, onCodeLanguageChange: onLanguageChange, onCodeOptionChange: onCodeOptionChange }))));
};
var getLinkToPropertiesDocumentation = function (codeType, insight) {
    if (codeType === "definition") {
        var meta = VisualizationCatalog_1.FullVisualizationCatalog.forInsight(insight).getMeta();
        if (meta === null || meta === void 0 ? void 0 : meta.documentationUrl) {
            return (meta === null || meta === void 0 ? void 0 : meta.documentationUrl) + "#properties";
        }
    }
    return INSIGHT_VIEW_PROPERTIES_LINK;
};
var generateCodeByReference = function (input) {
    var backend = input.backend, codeLang = input.codeLang, codeOption = input.codeOption, colorPalette = input.colorPalette, executionConfig = input.executionConfig, insight = input.insight, settings = input.settings;
    var height = sdk_ui_kit_1.getHeightWithUnitsForEmbedCode(codeOption);
    return insightViewCodeGenerator_1.insightViewCodeGenerator(insight, {
        context: {
            settings: settings,
            backend: backend,
            colorPalette: colorPalette,
            executionConfig: executionConfig,
        },
        language: codeLang,
        height: height,
        omitChartProps: codeOption.displayTitle ? [] : ["showTitle"],
    });
};
var generateCodeByDefinition = function (input) {
    var _a;
    var backend = input.backend, codeLang = input.codeLang, codeOption = input.codeOption, colorPalette = input.colorPalette, executionConfig = input.executionConfig, insight = input.insight, settings = input.settings;
    var height = sdk_ui_kit_1.getHeightWithUnitsForEmbedCode(codeOption);
    var descriptor = VisualizationCatalog_1.FullVisualizationCatalog.forInsight(insight);
    return (_a = descriptor.getEmbeddingCode) === null || _a === void 0 ? void 0 : _a.call(descriptor, insight, {
        context: {
            settings: settings,
            backend: backend,
            colorPalette: colorPalette,
            executionConfig: executionConfig,
        },
        language: codeLang,
        height: height,
        omitChartProps: codeOption.includeConfiguration ? [] : ["config"],
    });
};
var BUBBLE_ALIGN_POINTS = [{ align: "cc cc" }];
var ModalOverlay = function (props) {
    var children = props.children;
    return (react_1.default.createElement(sdk_ui_kit_1.Overlay, { alignPoints: BUBBLE_ALIGN_POINTS, isModal: true, positionType: "fixed" }, children));
};
//# sourceMappingURL=EmbedInsightDialog.js.map